$(".select_option").on("click", (e) => {
	let selectOption = e.target;
	let OptBox = $(selectOption).next();
	let selectIcon = $(selectOption).find(".custom_select_icon");
	if (OptBox.hasClass("none")) {
		OptBox.removeClass("none");
		OptBox.attr("data-select-opt-open", true);
	} else {
		OptBox.addClass("none");
		OptBox.attr("data-select-opt-open", false);
	}
	if (selectIcon.hasClass("select_open")) {
		selectIcon.removeClass("select_open");
	} else {
		selectIcon.addClass("select_open");
	}
});

$(document).on("click", (e) => {
	let y = $(document).find(`div[data-select-opt-open='${true}']`);
	let x = $(document).find(".select_open");
	if ($(e.target).is(".select_option")) {
		if (y.length > 1) {
			y.addClass("none");
			y.attr("data-select-opt-open", false);
			x.removeClass("select_open");
		}
	} else {
		if (y.length < 1) return;
		y.addClass("none");
		y.attr("data-select-opt-open", false);

		if (x.length == 1) {
			x.removeClass("select_open");
		}
	}
});

$(".options_container").on("click", (e) => {
	let optContainer = e.target;
	// query all options and remove class from current selected
	const optParent = $(optContainer).parent().children();
	$(optParent).find("div").removeClass("selected");
	let optionValue = $(optContainer).find(".custom-option");
	let z = optionValue
		.closest("div.custom-select-wrapper")
		.find("div#option-value");

	if (optionValue.length > 0) {
		const y = $(optionValue)
			.closest(".custom-select-wrapper")
			.find("#option-value");

		const placeholder = $(optContainer)
			.closest(".custom-select-opt")
			.closest(".custom-select-wrapper")
			.find("#option-value");

		if (y.length == 1) {
			// console.log(`OPTION VALUE`, optionValue.data("value"));
			if (typeof optionValue.data("value") === "number") {
				const o = optionValue.data("value");
				z.text(o);
				optionValue.addClass("selected");
				placeholder.removeClass("invalid_input");
			} else if (typeof optionValue.data("value") === "string") {
				// STRING VALUE OPTION SELECTED - Camel Case
				let o = optionValue.data("value")[0].toUpperCase(); // type narrow
				let optionData = optionValue.data("value").slice(1);
				if (z.length == 1) {
					z.text(o + optionData);
					optionValue.addClass("selected");
					placeholder.removeClass("invalid_input");
				}
			}
		}
	}
});

document.addEventListener("DOMContentLoaded", function () {
	const addToCartButton = document.querySelector("#add-to-cart-btn");
	const customSelects = document.querySelectorAll(".custom-select-wrapper");

	function updateATC() {
		let allOptionsSelected = true;
		const selectedV = [];
		customSelects.forEach((dropdown) => {
			const x = !dropdown.querySelector(
				".custom-option:not(#custom-value).selected"
			);
			// check for selected value in rendered options
			selectedV.push(x);
		});
		if (!selectedV.includes(true)) {
			addToCartButton.disabled = false;
			addToCartButton.style["pointer-events"] = "auto";
		}
	}

	// Map selection hidden default selector from custom
	document.querySelectorAll(".custom-select-wrapper").forEach((dropdown) => {
		dropdown.addEventListener("click", function (event) {
			const target = event.target;
			if (target.classList.contains("options_container")) {
				let option = target.querySelector(".custom-option");
				const selectId = dropdown.dataset.selectId;
				const value = option.dataset.value;
				// Update the actual select element
				// document.querySelector(`#Option-${selectId}`).value = value;
				let matchedSelector = document.querySelector(`#Option-${selectId}`);
				if (matchedSelector) {
					matchedSelector.value = value;
					const event = new Event("change", { bubbles: true });
					matchedSelector.dispatchEvent(event);
					// const atc = document.querySelector("#add-to-cart-btn");
					// atc.style["pointer-events"] = "auto";
					updateATC();
				}
			}
		});
	});
});

$(".atc").on("click", (e) => {
	let cartButton = e.target.querySelector("#add-to-cart-btn");
	if (cartButton) {
		// user selects variant
		document.querySelectorAll(".custom-select-wrapper").forEach((dropdown) => {
			let x = $(dropdown).find(".custom-select-opt");
			let y = x.children().find(".selected"); // if one option selected
			if (y.length === 0) {
				// if no selected option add invalid input
				const o = x.parent().find("#option-value");
				o.addClass("invalid_input");
			}
		});
	}
});
